import { Toast } from "primereact/toast";
import { useRef, useState } from "react";


import { Table } from "./Table";
import { IPermissionProps } from "../../models/Login";
import { ITarget } from "./ITarget";
import { EmptyTarget } from "./EmptyTarget";
import { Form } from "./Form";

export interface IModel {
    open: boolean,
    singleData: ITarget
}

export const TargetTemplate = (permissions: IPermissionProps) => {

    const [modal, setModal] = useState({ singleData: EmptyTarget, open: false } as IModel);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyTarget, open: false })
    };


    return (
        <>

            {permissions.is_View && <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload}></Table>}
            {(permissions.is_Create || permissions.is_Update) && <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>}
            <Toast ref={toast} />
        </>
    );
}
